module.exports = __webpack_public_path__ + "static/media/channel-wally.729f1ec5.svg";